// Capacitor-aware native shell initialization.
// Safe no-op on web — only runs when bundled inside the native Android/iOS app.
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { App as CapApp } from "@capacitor/app";
import { PushNotifications } from "@capacitor/push-notifications";
import { api } from "./api";

export const isNative = () => Capacitor.isNativePlatform();
export const nativePlatform = () => Capacitor.getPlatform(); // "android" | "ios" | "web"

export async function initNativeShell() {
    if (!isNative()) return;

    try {
        await StatusBar.setStyle({ style: Style.Light });
        await StatusBar.setBackgroundColor({ color: "#F6F5F2" });
    } catch (_) { /* iOS doesn't support setBackgroundColor */ }

    try {
        await SplashScreen.hide();
    } catch (_) {}

    // Hardware back button: navigate back, exit at root
    CapApp.addListener("backButton", ({ canGoBack }) => {
        if (canGoBack) window.history.back();
        else CapApp.exitApp();
    });
}

export async function registerNativePush() {
    if (!isNative()) return null;

    let perm = await PushNotifications.checkPermissions();
    if (perm.receive !== "granted") {
        perm = await PushNotifications.requestPermissions();
    }
    if (perm.receive !== "granted") {
        throw new Error("Push permission denied");
    }

    return new Promise((resolve, reject) => {
        const onReg = PushNotifications.addListener("registration", async (token) => {
            try {
                await api.post("/push/native/subscribe", {
                    platform: nativePlatform(),
                    token: token.value,
                });
                resolve(token.value);
            } catch (e) { reject(e); }
        });
        const onErr = PushNotifications.addListener("registrationError", (e) => reject(e));

        PushNotifications.register().catch(reject);

        // Cleanup listeners after first registration cycle
        setTimeout(async () => {
            try { (await onReg).remove(); } catch (_) {}
            try { (await onErr).remove(); } catch (_) {}
        }, 30000);
    });
}

export async function unregisterNativePush() {
    if (!isNative()) return;
    try {
        await api.post("/push/native/unsubscribe", { platform: nativePlatform() }).catch(() => {});
        await PushNotifications.unregister().catch(() => {});
    } catch (_) {}
}
